import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./toast-theme.css";
import GroupCollection from "./GroupCollection";
import CourseLandingPage from "./course-templates/CourseLandingPage";

function App() {
  return (
    <Router>
      {/* Global toast notifications (top-right corner) */}
      {/* zIndex above modal overlays (which use z-[9999]) so toasts are never
          hidden behind a dialog backdrop. */}
      <ToastContainer position="top-right" autoClose={3500} newestOnTop closeOnClick theme="light" style={{ zIndex: 100000 }} />
      <Routes>
        {/* Community page: /:token (e.g. /ddwrb). The group feed and the
            Members / Leaderboard / Rewards views all open inline here. */}
        <Route path="/:token" element={<GroupCollection />} />
        {/* Standalone course landing page (sales page, decoupled from the feed):
            /:community/:group/:course */}
        <Route path="/:token/:groupToken/:courseToken" element={<CourseLandingPage />} />
        <Route path="*" element={<NoCommunity />} />
      </Routes>
    </Router>
  );
}

function NoCommunity() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4 text-center text-sm text-gray-500">
      Add your community to the URL — e.g. <span className="font-medium ml-1">/your-community</span>.
    </div>
  );
}

export default App;
